
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.0335 16.5382L16.0333 16.5381L7.46191 7.96671C7.32221 7.82701 7.32235 7.60131 7.46181 7.46193L7.46191 7.46184C7.60148 7.32226 7.82737 7.32235 7.96668 7.46174L7.96677 7.46184L16.5381 16.0332C16.6778 16.1729 16.6777 16.3986 16.5382 16.538L16.5379 16.5382C16.4681 16.6082 16.3778 16.6428 16.2858 16.6428C16.1936 16.6428 16.1032 16.6081 16.0335 16.5382Z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M7.4621 16.5383L7.46181 16.538C7.3223 16.3986 7.3223 16.1728 7.46181 16.0334L7.46191 16.0333L16.0333 7.46191C16.1729 7.32221 16.3986 7.32235 16.538 7.46181L16.5381 7.46191C16.6777 7.60148 16.6776 7.82737 16.5382 7.96668L16.5381 7.96677L7.96677 16.5381L7.96658 16.5383C7.89682 16.6082 7.8064 16.6429 7.71425 16.6429C7.62221 16.6429 7.53194 16.6082 7.4621 16.5383Z","stroke":"currentColor"}})])
          )
        }
      }
    